import Box from "@mui/material/Box";
import {dividerClasses} from "@mui/material/Divider";
import {Skeleton} from "@mui/material";
import {useTheme} from "../../../contexts/theme";

const LoadingMachDayEvent = ({}) => {
    const theme = useTheme();
    const skeletonStyle = {backgroundColor: 'white', width: '100%', height: '100%'}

    return (
        <Box sx={{
        display: 'flex',
        justifyContent: 'space-between',
        '& svg': {
            m: 1,
        },
        [`& .${dividerClasses.root}`]: {
            mx: 0.5,
        },
    }}
    >
        <Box width="60%" sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            gap: theme.spacing.sm,
            padding: `${theme.spacing.sm} ${theme.spacing.sm}`,
        }}>
            <Box sx={{ display: 'flex'}}>
                <Box display={'flex'} justifyContent={'space-between'} width={'100%'} sx={{paddingRight: theme.spacing.sm}}>
                    <Box display='flex' justifyContent='center' flexDirection={'column'} width={'100%'} sx={{marginRight: theme.spacing.sm}}>
                        <Skeleton sx={skeletonStyle}/>
                    </Box>
                    <Box display='flex' justifyContent='center' flexDirection={'column'} width={'10px'}>
                        <Skeleton sx={skeletonStyle}/>
                    </Box>
                </Box>
            </Box>
            <Box sx={{ display: 'flex' }}>
                <Box display={'flex'} justifyContent={'space-between'} width={'100%'} sx={{paddingRight: theme.spacing.sm}}>
                    <Box display='flex' justifyContent='center' flexDirection={'column'} width={'100%'} sx={{marginRight: theme.spacing.sm}}>
                        <Skeleton sx={skeletonStyle}/>
                    </Box>
                    <Box display='flex' justifyContent='center' flexDirection={'column'} width={'10px'}>
                        <Skeleton sx={skeletonStyle}/>
                    </Box>
                </Box>
            </Box>
        </Box>
        <Box
            display={'flex'}
            flex={1}
            gap={theme.spacing.xs}
            justifyContent={'space-between'}
            flexDirection={"column"}
            sx={{
                padding: theme.spacing.sm,
                borderLeft:  `${theme.border.type.solid} ${theme.border.width.thin} ${theme.palette.white}`
            }}
        >
            <Skeleton sx={skeletonStyle}/>
            <Skeleton sx={skeletonStyle}/>
            <Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <Skeleton sx={skeletonStyle} variant="circular" width={15} height={15}/> {/*Mettere tondo*/}
                    <Skeleton sx={skeletonStyle}/>
                </Box>
            </Box>
        </Box>
        <Box
            display={'flex'}
            flex={1}
            justifyContent={'space-between'}
            flexDirection={"column"}
            sx={{
                padding: theme.spacing.sm,
                borderLeft:  `${theme.border.type.solid} ${theme.border.width.thin} ${theme.palette.white}`
            }}
        >
            <Skeleton sx={skeletonStyle}/>
            <Skeleton sx={skeletonStyle}/>
        </Box>
    </Box>
    );
}

export default LoadingMachDayEvent;